import React from 'react';
import { formatToBRL } from '../../../../utils/formatter';

const REF = '#a24aa2';
const RED = '#c62828';
const REF_HEAD = '#f3e8f3';
const RED_HEAD = '#fce8e6';
const BORDER = '#ccc';

function normalizeAdicional(a) {
  return a && a.pivot ? a.pivot : a;
}

function computeTotalRef(produtosRef) {
  let t = 0;
  let temLinhas = false;
  if (!produtosRef) return { total: 0, temLinhas: false };
  Object.keys(produtosRef).forEach((key) => {
    const p = produtosRef[key];
    const q = (p.produto_qtd || 0) > 0 || (p.reconsultas_qtd || 0) > 0;
    if (q) {
      temLinhas = true;
      t += parseFloat(p.produto_valor || 0) + parseFloat(p.reconsultas_valor || 0);
    }
  });
  return { total: t, temLinhas };
}

function computeTotalDin(produtos) {
  let t = 0;
  let temLinhas = false;
  if (!produtos) return { total: 0, temLinhas: false };
  Object.keys(produtos).forEach((key) => {
    const p = produtos[key];
    const q = (p.produto_qtd || 0) > 0 || (p.reconsultas_qtd || 0) > 0;
    if (q) {
      temLinhas = true;
      t += parseFloat(p.produto_valor || 0) + parseFloat(p.reconsultas_valor || 0);
    }
  });
  return { total: t, temLinhas };
}

const miniTableStyle = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: 11,
  marginTop: 6,
};

const thTd = (color, isHeader) => ({
  border: '1px solid #e0e0e0',
  padding: '4px 3px',
  color: isHeader ? color : color,
  textAlign: 'left',
});

export default function ExtratoResumo({ resume }) {
  const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 800px)').matches;
  const res = resume.resumo;
  const produtosRef = res.produtos_referencia || {};
  const produtosDin = res.produtos || {};
  const { total: totalRef, temLinhas: temLinhasRef } = computeTotalRef(produtosRef);
  const { total: totalDin, temLinhas: temLinhasDin } = computeTotalDin(produtosDin);

  const adicionaisRaw = res.adicionais || [];
  const temAdicionais = Array.isArray(adicionaisRaw) && adicionaisRaw.length > 0;

  const refNome = (res.referencia && (res.referencia.nome || res.referencia.nivel)) || '';
  const dinNome = (res.perfil_enquadrado && (res.perfil_enquadrado.nome || res.perfil_enquadrado.nivel)) || '';

  const gridCols = isMobile
    ? '1fr'
    : temAdicionais
      ? 'repeat(4, minmax(0, 1fr))'
      : 'repeat(3, minmax(0, 1fr))';

  const linhasAdicionais = temAdicionais
    ? adicionaisRaw.map((adicional) => {
        const a = normalizeAdicional(adicional);
        const parcelas = a.recorrencia ? '-' : a.parcelas ? `${a.parcela}/${a.parcelas}` : '-';
        return { a, parcelas };
      })
    : [];

  const valorAdicionalApi = typeof res.valor_adicional === 'number' ? res.valor_adicional : 0;

  const cob = res.cobranca;
  let vencStr = '';
  if (cob && cob.vencimento) {
    const p = cob.vencimento.split(' ')[0].split('-');
    if (p.length === 3) vencStr = `${p[2]}/${p[1]}/${p[0]}`;
  }

  const unitFmt = (u) => (u === 0 || u === '0' ? formatToBRL(0) : u);

  return (
    <div>
      <div
        style={{
          textAlign: 'center',
          fontSize: 15,
          fontWeight: 600,
          letterSpacing: '0.06em',
          marginBottom: 16,
          color: '#1565c0',
        }}
      >
        RESUMO
      </div>

      <div
        className="value-container"
        style={{
          display: 'grid',
          gridTemplateColumns: gridCols,
          gap: isMobile ? 12 : 10,
          alignItems: 'stretch',
          width: '100%',
        }}
      >
        {/* Coluna: faixa de referência */}
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: 5,
              color: REF,
            }}
          >
            Faixa de Referência do Cliente
          </div>
          <div
            style={{
              border: `1px solid ${BORDER}`,
              padding: '10px 8px',
              background: '#fff',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }}
          >
            <div style={{ fontSize: 10, marginBottom: 8, lineHeight: 1.35, color: REF, fontWeight: 600 }}>
              Faixa de Referência: {refNome}
            </div>
            {temLinhasRef ? (
              <table style={{ ...miniTableStyle, color: REF }}>
                <thead>
                  <tr style={{ background: REF_HEAD }}>
                    <th style={{ ...thTd(REF, true), width: '10%', textAlign: 'center' }}>QT</th>
                    <th style={{ ...thTd(REF, true), width: '38%' }}>Produto</th>
                    <th style={{ ...thTd(REF, true), textAlign: 'right', width: '26%' }}>$ UNI</th>
                    <th style={{ ...thTd(REF, true), textAlign: 'right', width: '26%' }}>$ Total</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(produtosRef).map((produto) => {
                    const p = produtosRef[produto];
                    if (!((p.produto_qtd || 0) > 0 || (p.reconsultas_qtd || 0) > 0)) return null;
                    return (
                      <React.Fragment key={produto}>
                        <tr>
                          <td style={{ ...thTd(REF, false), textAlign: 'center' }}>{p.produto_qtd}</td>
                          <td style={thTd(REF, false)}>{produto}</td>
                          <td style={{ ...thTd(REF, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                            R$ {unitFmt(p.produto_valor_unitario)}
                          </td>
                          <td style={{ ...thTd(REF, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                            R$ {formatToBRL(p.produto_valor)}
                          </td>
                        </tr>
                        {(p.reconsultas_qtd || 0) > 0 ? (
                          <tr>
                            <td style={{ ...thTd(REF, false), textAlign: 'center' }}>{p.reconsultas_qtd}</td>
                            <td style={thTd(REF, false)}>Reconsultas</td>
                            <td style={{ ...thTd(REF, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                              R$ {unitFmt(p.produto_valor_unitario)}
                            </td>
                            <td style={{ ...thTd(REF, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                              R$ {formatToBRL(p.reconsultas_valor)}
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            ) : null}
            <div style={{ marginTop: 8, fontSize: 10, textAlign: 'right', color: REF, fontWeight: 600 }}>
              Total: R$ {formatToBRL(totalRef)}
            </div>
            <div style={{ fontSize: 10, textAlign: 'right', color: REF }}>
              <small>Pagamento Mínimo: R$ {formatToBRL(parseFloat(String(res.consumo_minimo_referencia)))}</small>
            </div>
          </div>
        </div>

        {/* Coluna: precificação dinâmica */}
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: 5,
              color: RED,
            }}
          >
            Precificação Dinâmica
          </div>
          <div
            style={{
              border: `1px solid ${BORDER}`,
              padding: '10px 8px',
              background: '#fff',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
            }}
          >
            <div style={{ fontSize: 10, marginBottom: 8, lineHeight: 1.35, color: RED, fontWeight: 600 }}>
              Melhor Faixa pelo Consumo: {dinNome}
            </div>
            {temLinhasDin ? (
              <table style={{ ...miniTableStyle, color: RED }}>
                <thead>
                  <tr style={{ background: RED_HEAD }}>
                    <th style={{ ...thTd(RED, true), width: '10%', textAlign: 'center', color: RED }}>QT</th>
                    <th style={{ ...thTd(RED, true), width: '38%', color: RED }}>Produto</th>
                    <th style={{ ...thTd(RED, true), textAlign: 'right', width: '26%', color: RED }}>$ UNI</th>
                    <th style={{ ...thTd(RED, true), textAlign: 'right', width: '26%', color: RED }}>$ Total</th>
                  </tr>
                </thead>
                <tbody>
                  {Object.keys(produtosDin).map((produto) => {
                    const p = produtosDin[produto];
                    if (!((p.produto_qtd || 0) > 0 || (p.reconsultas_qtd || 0) > 0)) return null;
                    return (
                      <React.Fragment key={produto}>
                        <tr>
                          <td style={{ ...thTd(RED, false), textAlign: 'center' }}>{p.produto_qtd}</td>
                          <td style={thTd(RED, false)}>{produto}</td>
                          <td style={{ ...thTd(RED, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                            R$ {unitFmt(p.produto_valor_unitario)}
                          </td>
                          <td style={{ ...thTd(RED, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                            R$ {formatToBRL(p.produto_valor)}
                          </td>
                        </tr>
                        {(p.reconsultas_qtd || 0) > 0 ? (
                          <tr>
                            <td style={{ ...thTd(RED, false), textAlign: 'center' }}>{p.reconsultas_qtd}</td>
                            <td style={thTd(RED, false)}>Reconsultas</td>
                            <td style={{ ...thTd(RED, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                              R$ {unitFmt(p.produto_valor_unitario)}
                            </td>
                            <td style={{ ...thTd(RED, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                              R$ {formatToBRL(p.reconsultas_valor)}
                            </td>
                          </tr>
                        ) : null}
                      </React.Fragment>
                    );
                  })}
                </tbody>
              </table>
            ) : null}
            <div style={{ marginTop: 8, fontSize: 10, textAlign: 'right', color: RED, fontWeight: 600 }}>
              Total: R$ {formatToBRL(totalDin)}
            </div>
            <div style={{ fontSize: 10, textAlign: 'right', color: RED }}>
              <small>Pagamento Mínimo: R$ {formatToBRL(parseFloat(String(res.consumo_minimo)))}</small>
            </div>
          </div>
        </div>

        {/* Coluna opcional: itens adicionais */}
        {temAdicionais ? (
          <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
            <div
              style={{
                fontSize: 10,
                fontWeight: 'bold',
                textAlign: 'center',
                marginBottom: 5,
                color: RED,
              }}
            >
              Itens adicionais
            </div>
            <div
              style={{
                border: `1px solid ${BORDER}`,
                padding: '10px 8px',
                background: '#fff',
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
              }}
            >
              <table style={{ ...miniTableStyle, color: RED }}>
                <thead>
                  <tr style={{ background: RED_HEAD }}>
                    <th style={{ ...thTd(RED, true), width: '22%', color: RED }}>Tipo</th>
                    <th style={{ ...thTd(RED, true), width: '38%', color: RED }}>Descrição</th>
                    <th style={{ ...thTd(RED, true), width: '15%', color: RED }}>Parcela</th>
                    <th style={{ ...thTd(RED, true), width: '25%', textAlign: 'right', color: RED }}>Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {linhasAdicionais.map(({ a, parcelas }, idx) => (
                    <tr key={idx}>
                      <td style={thTd(RED, false)}>{a.tipo}</td>
                      <td style={thTd(RED, false)}>{a.descricao}</td>
                      <td style={thTd(RED, false)}>{parcelas}</td>
                      <td style={{ ...thTd(RED, false), textAlign: 'right', whiteSpace: 'nowrap' }}>
                        R$ {a.tipo === 'DESCONTO' ? '-' : ''}
                        {a.valor ? formatToBRL(a.valor) : formatToBRL((res.valor_pago_numero * (a.percentual || 0)) / 100)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div style={{ marginTop: 8, fontSize: 10, textAlign: 'right', color: RED, fontWeight: 600 }}>
                Total: R$ {formatToBRL(valorAdicionalApi)}
              </div>
            </div>
          </div>
        ) : null}

        {/* Coluna: cobrança e valor final */}
        <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
          {/* Espaço equivalente ao título das outras colunas */}
          <div style={{ height: 20, marginBottom: 5, flexShrink: 0 }} aria-hidden />
          <div
            style={{
              border: `1px solid ${BORDER}`,
              padding: '10px 12px',
              background: '#fff',
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              minHeight: 0,
              justifyContent: 'center',
            }}
          >
            {temAdicionais ? (
              <div style={{ fontSize: 10, lineHeight: 1.5, marginBottom: 10 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                  <tbody>
                    <tr className="extrato-resumo-red-tot" style={{ color: RED, fontWeight: 600 }}>
                      <td style={{ textAlign: 'left', padding: '0 0 4px' }}>Prec. Dinâmica:</td>
                      <td style={{ textAlign: 'right', padding: '0 0 4px', whiteSpace: 'nowrap' }}>
                        R$ {formatToBRL(res.valor_pago_numero)}
                      </td>
                    </tr>
                    <tr style={{ color: RED, fontWeight: 600 }}>
                      <td style={{ textAlign: 'left', padding: '0 0 4px' }}>Adicional:</td>
                      <td style={{ textAlign: 'right', padding: '0 0 4px', whiteSpace: 'nowrap' }}>
                        R$ {formatToBRL(valorAdicionalApi)}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <hr style={{ border: 'none', borderTop: `1px solid ${BORDER}`, margin: '8px 0 0' }} />
              </div>
            ) : null}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-end',
                justifyContent: 'space-between',
                gap: '10px 16px',
              }}
            >
              <div
                style={{
                  fontSize: 13,
                  color: '#334155',
                  lineHeight: 1.5,
                  fontWeight: 500,
                  minWidth: 0,
                  flex: '1 1 140px',
                }}
              >
                {cob ? (
                  <React.Fragment>
                    Cobrança: {cob.id}
                    <br />
                    Venc.: {vencStr}
                    <br />
                    Status: {cob.status}
                  </React.Fragment>
                ) : null}
              </div>
              <div style={{ textAlign: 'right', flexShrink: 0 }}>
                <div style={{ fontSize: 14, fontWeight: 'normal', color: '#000', marginBottom: 4 }}>VALOR À PAGAR</div>
                <div style={{ fontSize: 18, fontWeight: 'bold', color: '#000' }}>
                  R$ {formatToBRL(res.valor_final)}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
